export default "__VITE_ASSET__vqCcJxHs__"